import { yupResolver } from "@hookform/resolvers/yup";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import Button from "components/Button";
import Input from "components/Input";
import LinkButton from "components/LinkButton";
import ModalComponent from "components/ModalComponent";
import { useRegister } from "providers/Register";
import { ProfessionalRegisterAccessData } from "types/register";

import GeneralTerms from "../../../../../components/GeneralTerms";

const ProfessionalAccessDataForm = () => {
  const navigate = useNavigate();
  const { isLoading, registerProfessional } = useRegister();
  const [termsModalShow, setTermsModalShow] = useState(false);

  const schema = yup.object().shape({
    professionalRegister: yup.string().trim(),
    rqe: yup.string().trim(),
    email: yup
      .string()
      .required("*Campo obrigatório")
      .email("*Formato inválido"),
    password: yup
      .string()
      .required("*Campo obrigatório")
      .min(8, "*A senha deve ter pelo menos 8 caracteres")
      .matches(
        RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})(?=.*[!.@#$%^&*\"'¨()_+=`´{}~,<>;:?|\\]\\\\/[-])"
        ),
        "*Formato inválido"
      ),
    isAccepted: yup
      .boolean()
      .test(
        "termsValidator",
        "*É necessário concordar com os termos para completar o cadastro",
        (value) => !!value
      ),
    termsOfUse: yup.string(),
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<ProfessionalRegisterAccessData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: ProfessionalRegisterAccessData) => {
    delete data.isAccepted;
    registerProfessional(data, navigate);
  };

  const handleTermsOfUseInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setValue("isAccepted", true);
      setValue("termsOfUse", moment().toISOString(true));
    } else {
      setValue("isAccepted", false);
    }
  };

  return (
    <>
      <form className="p-3 p-sm-4 p-xl-5" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-box p-3 p-sm-4 p-xl-5">
          <header className="row flex-nowrap pt-3 pb-4">
            <div className="col">
              <h5>Dados Profissionais</h5>
            </div>
            <div className="col col-auto text-muted">
              <b className="text-primary">3</b>
              /3
            </div>
          </header>
          <div className="row align-items-end">
            <div className="col-md-6">
              <div className="form-group">
                <Input
                  label="Registro Profissional:"
                  placeholder="12345"
                  type="text"
                  register={register("professionalRegister")}
                  error={errors?.professionalRegister?.message}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <Input
                  label="Especialidade:"
                  placeholder="12345"
                  type="tel"
                  register={register("rqe")}
                  error={errors?.rqe?.message}
                />
              </div>
            </div>
          </div>

          <hr className="my-4 pb-3" />

          <h5 className="pb-4">Dados de Acesso</h5>
          <div className="form-group">
            <Input
              label="E-mail:"
              placeholder="seu@email.com"
              type="text"
              register={register("email")}
              error={errors?.email?.message}
            />
            <small id="emailHelp" className="form-text text-muted">
              Nunca compartilharemos seu email.
            </small>
          </div>

          <div className="form-group">
            <Input
              label="Senha:"
              isPasswordInput
              register={register("password")}
              error={errors?.password?.message}
            />
            <small id="emailHelp" className="form-text text-muted">
              Utilize letras maiúsculas e minúsculas, números e caracteres
              especiais (*#.!@)
            </small>
          </div>

          <div className="form-group">
            <label
              htmlFor="acceptTerms"
              className="control control--checkbox mb-0"
            >
              <span className="caption">
                Ao prosseguir você concorda com os{" "}
                <LinkButton
                  className="align-baseline fs-6"
                  onClick={() => setTermsModalShow(true)}
                >
                  Termos Gerais
                </LinkButton>
                .
              </span>
              <input
                id="acceptTerms"
                type="checkbox"
                {...register("isAccepted")}
                onChange={handleTermsOfUseInput}
              />
              <div
                className={`control__indicator ${
                  !!errors?.isAccepted && "border border-danger"
                }`}
              ></div>
            </label>
            <div className="text-danger mb-3">
              <small>{!!errors?.isAccepted && errors.isAccepted.message}</small>
            </div>
          </div>
        </div>

        <div className="row no-gutters justify-content-between pt-3 pt-sm-4 pt-xl-5">
          <div className="col col-auto">
            <Button
              className="btn-light"
              type="button"
              disabled={isLoading}
              onClick={() => navigate(-1)}
            >
              Voltar
            </Button>
          </div>
          <div className="col col-auto">
            <Button className="btn-primary" type="submit" disabled={isLoading}>
              Finalizar
              {!!isLoading && (
                <CircularProgress
                  color="inherit"
                  size={12}
                  className="align-text-top ms-2"
                />
              )}
            </Button>
          </div>
        </div>
      </form>

      {/* Modal de Termos */}
      <ModalComponent
        title="Termos Gerais"
        show={termsModalShow}
        onHide={() => setTermsModalShow(false)}
        size="lg"
        keyboard={false}
      >
        <GeneralTerms />
      </ModalComponent>
    </>
  );
};

export default ProfessionalAccessDataForm;
